import { Timestamp } from 'firebase/firestore';
import { getNextMonth } from '../pages/BalanceFlow/balanceUtils';

export interface IBaseInstrument {
  id: string;
  displayName: string;
  unit: 'mt' | 't' | 'st'; // [Recheck]
  amountPerContract: number; // For Example 10 mt per contract
  source: 'Refinitiv';
}

export interface IInstrument {
  id: string;
  baseInstrumentId: string;
  expiryDate: Timestamp;
  expectedPrice: number;
  maximumPrice: number;
  lastPrice: number;
}

export const refinitivMonthCodes: { [key: number]: string } = {
  0: 'F', // January
  1: 'G', // February
  2: 'H', // March
  3: 'J', // April
  4: 'K', // May
  5: 'M', // June
  6: 'N', // July
  7: 'Q', // August
  8: 'U', // September
  9: 'V', // October
  10: 'X', // November
  11: 'Z', // December
};

const getNextLetter = (date: Date, monthLetters: string): { letter: string; year: number } => {
  let myDate = { month: date.getMonth() + 1, year: date.getFullYear() };

  for (let i = 0; i < 6; i++) {
    const nextMonth = getNextMonth(myDate);
    if (monthLetters.includes(refinitivMonthCodes[nextMonth.month - 1])) {
      return { letter: refinitivMonthCodes[nextMonth.month - 1], year: nextMonth.year };
    }
    myDate = nextMonth;
  }
  return { letter: '', year: 0 };
};

export function getInstrumentKey(date: Date, char1Year: boolean = false, monthLetters?: string): string {
  const year = date
    .getFullYear()
    .toString()
    .slice(char1Year ? -1 : -2);

  const result = { letter: refinitivMonthCodes[date.getMonth()], year };

  if (monthLetters && !monthLetters.includes(result.letter)) {
    const { letter, year } = getNextLetter(date, monthLetters);
    return `${letter}${year.toString().slice(char1Year ? -1 : -2)}`;
  }

  return `${result.letter}${result.year}`;
}

export const mockBaseInstrumentsToCreate: IBaseInstrument[] = [
  { id: 'HRC', amountPerContract: 20, displayName: 'HRC MW', source: 'Refinitiv', unit: 'mt' },
  { id: 'CSRR', amountPerContract: 10, displayName: 'LME Steel RebarFOB', source: 'Refinitiv', unit: 'st' },
];

export const mockInstrumentToCreate: IInstrument[] = [
  {
    id: 'HRCF24',
    baseInstrumentId: 'HRC',
    expiryDate: Timestamp.fromDate(new Date('2024-01-25T00:00:00Z')),
    expectedPrice: 718,
    maximumPrice: 730,
    lastPrice: 718,
  },
  {
    id: 'HRCG24',
    baseInstrumentId: 'HRC',
    expiryDate: Timestamp.fromDate(new Date('2024-02-25T00:00:00Z')),
    expectedPrice: 745,
    maximumPrice: 752,
    lastPrice: 746,
  }, //Febru
  {
    id: 'HRCH24',
    baseInstrumentId: 'HRC',
    expiryDate: Timestamp.fromDate(new Date('2024-03-25T00:00:00Z')),
    expectedPrice: 745,
    maximumPrice: 752,
    lastPrice: 745,
  }, // March
  {
    id: 'HRCJ24',
    baseInstrumentId: 'HRC',
    expiryDate: Timestamp.fromDate(new Date('2024-04-25T00:00:00Z')),
    expectedPrice: 740,
    maximumPrice: 745,
    lastPrice: 724,
  }, // Apr
  {
    id: 'HRCK24',
    baseInstrumentId: 'HRC',
    expiryDate: Timestamp.fromDate(new Date('2024-05-25T00:00:00Z')),
    expectedPrice: 737,
    maximumPrice: 742,
    lastPrice: 726,
  }, // Mau
  {
    id: 'HRCM24',
    baseInstrumentId: 'HRC',
    expiryDate: Timestamp.fromDate(new Date('2024-06-25T00:00:00Z')),
    expectedPrice: 732,
    maximumPrice: 738,
    lastPrice: 728,
  }, // Jun
  {
    id: 'HRCN24',
    baseInstrumentId: 'HRC',
    expiryDate: Timestamp.fromDate(new Date('2024-07-25T00:00:00Z')),
    expectedPrice: 727,
    maximumPrice: 732,
    lastPrice: 730,
  }, // Jul
  {
    id: 'HRCQ24',
    baseInstrumentId: 'HRC',
    expiryDate: Timestamp.fromDate(new Date('2024-08-25T00:00:00Z')),
    expectedPrice: 721,
    maximumPrice: 726,
    lastPrice: 732,
  }, // aug
  {
    id: 'HRCU24',
    baseInstrumentId: 'HRC',
    expiryDate: Timestamp.fromDate(new Date('2024-09-25T00:00:00Z')),
    expectedPrice: 716,
    maximumPrice: 721,
    lastPrice: 734,
  }, // sep
  {
    id: 'HRCV24',
    baseInstrumentId: 'HRC',
    expiryDate: Timestamp.fromDate(new Date('2024-10-25T00:00:00Z')),
    expectedPrice: 716,
    maximumPrice: 721,
    lastPrice: 736,
  }, // oct
  {
    id: 'HRCX24',
    baseInstrumentId: 'HRC',
    expiryDate: Timestamp.fromDate(new Date('2024-11-25T00:00:00Z')),
    expectedPrice: 716,
    maximumPrice: 721,
    lastPrice: 738,
  }, // nobc
  {
    id: 'HRCZ24',
    baseInstrumentId: 'HRC',
    expiryDate: Timestamp.fromDate(new Date('2024-12-25T00:00:00Z')),
    expectedPrice: 716,
    maximumPrice: 721,
    lastPrice: 740,
  }, // dec

  {
    id: 'HRCF25',
    baseInstrumentId: 'HRC',
    expiryDate: Timestamp.fromDate(new Date('2025-01-25T00:00:00Z')),
    expectedPrice: 742,
    maximumPrice: 754,
    lastPrice: 742,
  },
  {
    id: 'HRCG25',
    baseInstrumentId: 'HRC',
    expiryDate: Timestamp.fromDate(new Date('2025-02-25T00:00:00Z')),
    expectedPrice: 744,
    maximumPrice: 756,
    lastPrice: 744,
  },
  {
    id: 'HRCH25',
    baseInstrumentId: 'HRC',
    expiryDate: Timestamp.fromDate(new Date('2025-03-25T00:00:00Z')),
    expectedPrice: 746,
    maximumPrice: 758,
    lastPrice: 746,
  },
  {
    id: 'HRCJ25',
    baseInstrumentId: 'HRC',
    expiryDate: Timestamp.fromDate(new Date('2025-04-25T00:00:00Z')),
    expectedPrice: 748,
    maximumPrice: 760,
    lastPrice: 748,
  },
  {
    id: 'HRCK25',
    baseInstrumentId: 'HRC',
    expiryDate: Timestamp.fromDate(new Date('2025-05-25T00:00:00Z')),
    expectedPrice: 750,
    maximumPrice: 762,
    lastPrice: 750,
  },
  {
    id: 'HRCM25',
    baseInstrumentId: 'HRC',
    expiryDate: Timestamp.fromDate(new Date('2025-06-25T00:00:00Z')),
    expectedPrice: 752,
    maximumPrice: 764,
    lastPrice: 752,
  },
  {
    id: 'HRCN25',
    baseInstrumentId: 'HRC',
    expiryDate: Timestamp.fromDate(new Date('2025-07-25T00:00:00Z')),
    expectedPrice: 754,
    maximumPrice: 766,
    lastPrice: 754,
  },
  {
    id: 'HRCQ25',
    baseInstrumentId: 'HRC',
    expiryDate: Timestamp.fromDate(new Date('2025-08-25T00:00:00Z')),
    expectedPrice: 756,
    maximumPrice: 768,
    lastPrice: 756,
  },
  {
    id: 'HRCU25',
    baseInstrumentId: 'HRC',
    expiryDate: Timestamp.fromDate(new Date('2025-09-25T00:00:00Z')),
    expectedPrice: 758,
    maximumPrice: 770,
    lastPrice: 758,
  },
  {
    id: 'HRCV25',
    baseInstrumentId: 'HRC',
    expiryDate: Timestamp.fromDate(new Date('2025-10-25T00:00:00Z')),
    expectedPrice: 760,
    maximumPrice: 772,
    lastPrice: 760,
  },
  {
    id: 'HRCX25',
    baseInstrumentId: 'HRC',
    expiryDate: Timestamp.fromDate(new Date('2025-11-25T00:00:00Z')),
    expectedPrice: 762,
    maximumPrice: 774,
    lastPrice: 762,
  },
  {
    id: 'HRCZ25',
    baseInstrumentId: 'HRC',
    expiryDate: Timestamp.fromDate(new Date('2025-12-25T00:00:00Z')),
    expectedPrice: 764,
    maximumPrice: 776,
    lastPrice: 764,
  },

  {
    id: 'CSRRM24',
    baseInstrumentId: 'CSRR',
    expiryDate: Timestamp.fromDate(new Date('2024-06-25T00:00:00Z')),
    expectedPrice: 528,
    maximumPrice: 540,
    lastPrice: 528,
  }, // Jun
  {
    id: 'CSRRN24',
    baseInstrumentId: 'CSRR',
    expiryDate: Timestamp.fromDate(new Date('2024-07-25T00:00:00Z')),
    expectedPrice: 530,
    maximumPrice: 542,
    lastPrice: 530,
  }, // Jul
  {
    id: 'CSRRQ24',
    baseInstrumentId: 'CSRR',
    expiryDate: Timestamp.fromDate(new Date('2024-08-25T00:00:00Z')),
    expectedPrice: 532,
    maximumPrice: 544,
    lastPrice: 532,
  },
  {
    id: 'CSRRU24',
    baseInstrumentId: 'CSRR',
    expiryDate: Timestamp.fromDate(new Date('2024-09-25T00:00:00Z')),
    expectedPrice: 534,
    maximumPrice: 546,
    lastPrice: 534,
  },
  {
    id: 'CSRRV24',
    baseInstrumentId: 'CSRR',
    expiryDate: Timestamp.fromDate(new Date('2024-10-25T00:00:00Z')),
    expectedPrice: 536,
    maximumPrice: 548,
    lastPrice: 536,
  },
  {
    id: 'CSRRX24',
    baseInstrumentId: 'CSRR',
    expiryDate: Timestamp.fromDate(new Date('2024-11-25T00:00:00Z')),
    expectedPrice: 538,
    maximumPrice: 550,
    lastPrice: 538,
  },
  {
    id: 'CSRRZ24',
    baseInstrumentId: 'CSRR',
    expiryDate: Timestamp.fromDate(new Date('2024-12-25T00:00:00Z')),
    expectedPrice: 540,
    maximumPrice: 552,
    lastPrice: 540,
  },
  {
    id: 'CSRRF25',
    baseInstrumentId: 'CSRR',
    expiryDate: Timestamp.fromDate(new Date('2025-01-25T00:00:00Z')),
    expectedPrice: 542,
    maximumPrice: 554,
    lastPrice: 542,
  },
  {
    id: 'CSRRG25',
    baseInstrumentId: 'CSRR',
    expiryDate: Timestamp.fromDate(new Date('2025-02-25T00:00:00Z')),
    expectedPrice: 544,
    maximumPrice: 556,
    lastPrice: 544,
  },
  {
    id: 'CSRRH25',
    baseInstrumentId: 'CSRR',
    expiryDate: Timestamp.fromDate(new Date('2025-03-25T00:00:00Z')),
    expectedPrice: 546,
    maximumPrice: 558,
    lastPrice: 546,
  },
  {
    id: 'CSRRJ25',
    baseInstrumentId: 'CSRR',
    expiryDate: Timestamp.fromDate(new Date('2025-04-25T00:00:00Z')),
    expectedPrice: 548,
    maximumPrice: 560,
    lastPrice: 548,
  },
  {
    id: 'CSRRK25',
    baseInstrumentId: 'CSRR',
    expiryDate: Timestamp.fromDate(new Date('2025-05-25T00:00:00Z')),
    expectedPrice: 550,
    maximumPrice: 562,
    lastPrice: 550,
  },
  {
    id: 'CSRRM25',
    baseInstrumentId: 'CSRR',
    expiryDate: Timestamp.fromDate(new Date('2025-06-25T00:00:00Z')),
    expectedPrice: 552,
    maximumPrice: 564,
    lastPrice: 552,
  },
  {
    id: 'CSRRN25',
    baseInstrumentId: 'CSRR',
    expiryDate: Timestamp.fromDate(new Date('2025-07-25T00:00:00Z')),
    expectedPrice: 554,
    maximumPrice: 566,
    lastPrice: 554,
  },
  {
    id: 'CSRRQ25',
    baseInstrumentId: 'CSRR',
    expiryDate: Timestamp.fromDate(new Date('2025-08-25T00:00:00Z')),
    expectedPrice: 556,
    maximumPrice: 568,
    lastPrice: 556,
  },
  {
    id: 'CSRRU25',
    baseInstrumentId: 'CSRR',
    expiryDate: Timestamp.fromDate(new Date('2025-09-25T00:00:00Z')),
    expectedPrice: 558,
    maximumPrice: 570,
    lastPrice: 558,
  },
  {
    id: 'CSRRV25',
    baseInstrumentId: 'CSRR',
    expiryDate: Timestamp.fromDate(new Date('2025-10-25T00:00:00Z')),
    expectedPrice: 560,
    maximumPrice: 572,
    lastPrice: 560,
  },
  {
    id: 'CSRRX25',
    baseInstrumentId: 'CSRR',
    expiryDate: Timestamp.fromDate(new Date('2025-11-25T00:00:00Z')),
    expectedPrice: 562,
    maximumPrice: 574,
    lastPrice: 562,
  },
  {
    id: 'CSRRZ25',
    baseInstrumentId: 'CSRR',
    expiryDate: Timestamp.fromDate(new Date('2025-12-25T00:00:00Z')),
    expectedPrice: 564,
    maximumPrice: 576,
    lastPrice: 564,
  },
];
